import selectGridSubheaderBreadcrumb from 'app/redux/betting-presentation/grid/selectors/gridSubheaderBreadCrumb';

import { matches, sports, tournaments, tournamentStages, tournamentUnions } from './entities';

export const gridSubheaderBreadcrumbSelector = selectGridSubheaderBreadcrumb(
  matches,
  sports,
  tournamentStages,
  tournaments,
  tournamentUnions,
);
